<template>
  <div>
    <div class="form-horizontal">
      <div class="filter-panel" :class="{
        'is-sticky': stickyFilters
      }">
        <form @submit.prevent class="flex flex-row search-bar">
          <div class="w-full search-bar__input" v-if="areaModel === 'career'">
            <tag-picker
              input-id="search"
              :current="selectedNodes"
              :full-width="true"
              :with-icon="false"
              :with-popper="false"
              :can-add="false"
              :placeholder="searchPlaceholder"
              @selected="handleNodeSelected"
              :default-fetch="true"/>
          </div>
          <input v-else v-model="searchModel" class="form-control our-stars-search search-bar__input" :placeholder="searchPlaceholder">
          <selectize
            class="selectize selectize-control selectize-single search-bar__input search-bar__select"
            name="search_area"
            :disable-delete="true"
            :options="searchAreaOptions"
            v-model="areaModel"/>
          <ladda-button class="btn btn-sm btn-primary flex-shrink-0" :click="handleSearchSelected">
            Search
          </ladda-button>
        </form>
        <div class="filter-row">
          <div class="filter-group" v-if="$vlastMode">
            <label class="sr-only">Verification Status</label>
            <selectize
              class="selectize selectize-control selectize-single"
              name="verification_status"
              ref="verification_status"
              :options="verificationStatusOptions"
              placeholder="Verification Status"
              @input="getStarsHelper"
              v-model="stateVerificationStatus"/>
          </div>
          <div class="filter-group" v-show="regionOptions.length > 1">
            <label class="sr-only">Region</label>
            <filter-tags
              ref="region"
              name="region"
              class="selectize selectize-multiple selectized our-stars-region"
              @input="getStarsHelper"
              v-model="stateRegion"
              key-context="region"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              placeholder="Region"
              :options="regionOptions"/>
          </div>
          <!-- Based In Filter -->
          <div class="filter-group">
            <label class="sr-only">Based In</label>
            <filter-tags
              ref="based_in"
              name="based_in"
              class="selectize selectized our-stars-location"
              :class="$cumulativeSearchEnabled ? 'selectize-single' : 'selectize-multiple'"
              :multiple="!$cumulativeSearchEnabled"
              @input="getStarsHelper"
              v-model="stateBasedIn"
              key-context="based_in"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              :fetch-results="fetchLocationResultsCallback"
              :pre-load="true"
              placeholder="Based In"/>
            <a class="pull-right cursor-pointer" v-if="$cumulativeSearchEnabled" @click="() => { handleClearFilter('based_in') }">Clear Filter</a>
          </div>
          <div class="filter-group" v-if="basedInRegionOptions && basedInRegionOptions.length && showAll">
            <label class="sr-only">Subregion</label>
            <filter-tags
              key="location_region"
              ref="location_region"
              name="location_region"
              class="selectize selectized our-stars-location"
              :class="$cumulativeSearchEnabled ? 'selectize-single' : 'selectize-multiple'"
              :multiple="!$cumulativeSearchEnabled"
              @input="getStarsHelper"
              v-model="stateLocationRegionBasedIn"
              key-context="location_region"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              :options="basedInRegionOptions"
              placeholder="Subregion"/>
            <a class="pull-right cursor-pointer" v-if="$cumulativeSearchEnabled" @click="() => { handleClearFilter('location_region') }">Clear Filter</a>
          </div>
          <div class="filter-group" v-if="basedInRegionOptions && basedInRegionOptions.length && !showAll">
            <label class="sr-only">Subregion</label>
            <filter-tags
              key="location_region2"
              ref="location_region"
              name="location_region"
              class="selectize selectized our-stars-location"
              :class="$cumulativeSearchEnabled ? 'selectize-single' : 'selectize-multiple'"
              :multiple="!$cumulativeSearchEnabled"
              @input="getStarsHelper"
              v-model="stateLocationRegionBasedIn"
              key-context="location_region"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              :options="basedInRegionOptions"
              placeholder="Subregion"/>
            <a class="pull-right cursor-pointer" v-if="$cumulativeSearchEnabled" @click="() => { handleClearFilter('location_region') }">Clear Filter</a>
          </div>
          <!-- Sport Filter -->
          <div class="filter-group" v-if="!$isNflClub && !$hasTagNodes">
            <label class="sr-only">Sport Category</label>
            <filter-tags
              ref="sport"
              name="sport"
              class="selectize selectize-multiple selectized our-stars-sport"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="sport"
              :placeholder="$vlastMode ? $t('Category') : 'Sports'"
              v-model="stateSport"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'sport') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'sport') }"
              :options="sport"/>
          </div>

          <!-- Gender Filter -->
          <div class="filter-group" v-if="$genderModuleEnabled">
            <label class="sr-only">Gender</label>
            <filter-tags
              ref="gender"
              name="gender"
              class="selectize selectized our-stars-gender"
              :class="$cumulativeSearchEnabled ? 'selectize-single' : 'selectize-multiple'"
              :multiple="!$cumulativeSearchEnabled"
              @input="getStarsHelper"
              v-model="stateGender"
              key-context="gender"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              placeholder="Gender"
              :options=genderOptions />
            <a class="pull-right cursor-pointer" v-if="$cumulativeSearchEnabled" @click="() => { handleClearFilter('gender') }">Clear Filter</a>
          </div>

          <div class="filter-group" v-if="(regionOptions.length <= 1 || !$genderModuleEnabled || $hasTagNodes) && !$hideSocialMediaReferences">
            <label class="sr-only">Social Following</label>
            <filter-tags
              ref="social_following"
              name="social_following"
              class="selectize selectize-multiple selectized our-stars-social-following"
              @input="getStarsHelper"
              v-model="stateSocialFollowing"
              key-context="social_following"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              placeholder="Social Following"
              :options="social_following"/>
          </div>

          <!-- Club/Event Filter -->
          <div class="filter-group" v-if="regionOptions.length <= 1 && !$genderModuleEnabled && !$hasTagNodes">
            <label class="sr-only">{{ $t('Club / Event')}}</label>
            <filter-tags
              ref="club"
              name="club"
              class="selectize selectize-multiple selectized our-stars-club"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="club"
              :placeholder="$t('Club / Event')"
              v-model="stateClub"
              :options="club"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'club') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'club') }" />
          </div>

          <div class="filter-group" v-if="$vlastMode && $userIsAdmin">
            <label class="sr-only">{{ $t('organisation name') }}</label>
            <filter-tags
              ref="client"
              class="selectize selectize-multiple selectized"
              name="client"
              @input="getStarsHelper"
              v-model="stateClient"
              key-context="client"
              :multiple="true"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              :pre-load="true"
              :fetch-results="fetchClientsCallback"
              :fetch-more-results="fetchNextClientsCallback"
              :placeholder="$options.filters.titleCase($t('organisation name'))"
              :options="clientUsers"/>
          </div>
        </div>

        <div id="collapse-more-options" class="filter-row" v-show="showAll">

          <div class="filter-group" v-if="(regionOptions.length > 1 && $genderModuleEnabled && !$hasTagNodes) && !$hideSocialMediaReferences">
            <label class="sr-only">Social Following</label>
            <filter-tags
              ref="social_following"
              name="social_following"
              class="selectize selectize-multiple selectized our-stars-social-following"
              @input="getStarsHelper"
              v-model="stateSocialFollowing"
              key-context="social_following"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              placeholder="Social Following"
              :options="social_following"/>
          </div>

          <!-- Club/Event Filter -->
          <div class="filter-group" v-if="(regionOptions.length > 1 || $genderModuleEnabled) && !$hasTagNodes">
            <label class="sr-only">{{ $t('Club / Event')}}</label>
            <filter-tags
              ref="club"
              name="club"
              class="selectize selectize-multiple selectized our-stars-club"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="club"
              :placeholder="$t('Club / Event')"
              v-model="stateClub"
              :options="club"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'club') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'club') }" />
          </div>

          <div class="filter-group" v-if="!$hasTagNodes">
            <label class="sr-only">Industry</label>
            <filter-tags
              ref="industry"
              name="industry"
              class="selectize selectize-multiple selectized our-stars-industry"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="industry"
              placeholder="Industry"
              v-model="stateIndustry"
              :options="industry"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'industry') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'industry') }"/>
          </div>

          <div class="filter-group" v-if="$hasInterestCategories">
            <label class="sr-only">Interest Categories</label>
            <filter-tags
              ref="interestCategories"
              name="interestCategories"
              class="selectize selectize-multiple selectized our-stars-interestCategories"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="interestCategories"
              placeholder="Interest Categories"
              v-model="stateInterestCategories"
              :options="interestCategories"
              :fetch-results="(term, callback) => { fetchInterestCategoriesCallback(term, callback) }"
              :fetch-more-results="(term, callback) => { fetchMoreInterestCategoriesCallback(term, callback) }"/>
          </div>

          <div class="filter-group" v-if="$hasInterestCategories">
            <label class="sr-only">Specialist Categories</label>
            <filter-tags
              ref="specialistTopics"
              name="specialistTopics"
              class="selectize selectize-multiple selectized our-stars-specialistTopics"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="specialistTopics"
              placeholder="Specialist Categories"
              v-model="stateSpecialistTopics"
              :options="specialistTopics"
              :fetch-results="(term, callback) => { fetchSpecialistTopicsCallback(term, callback) }"
              :fetch-more-results="(term, callback) => { fetchMoreSpecialistTopicsCallback(term, callback) }"/>
          </div>

          <div class="filter-group" v-if="$hasPersonalInterests">
            <label class="sr-only">Hobbies</label>
            <filter-tags
              ref="personalInterests"
              name="personalInterests"
              class="selectize selectize-multiple selectized our-stars-personalInterests"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="personalInterests"
              placeholder="Hobbies"
              v-model="statePersonalInterests"
              :options="personalInterests"
              :fetch-results="(term, callback) => { fetchPersonalInterestsCallback(term, callback) }"
              :fetch-more-results="(term, callback) => { fetchMorePersonalInterestsCallback(term, callback) }"/>
          </div>

          <div class="filter-group" v-if="!$isNflClub">
            <label class="sr-only">Available In</label>
            <filter-tags
              ref="availableIn"
              name="available_in"
              class="selectize selectize-multiple selectized our-stars-location"
              @input="getStarsHelper"
              v-model="stateAvailableIn"
              key-context="available_in"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              :fetch-results="fetchLocationResultsCallback"
              :pre-load="true"
              placeholder="Available In"/>
          </div>

          <!-- Club/Event Filter -->
          <div class="filter-group" v-if="$multipleLeagues">
            <label class="sr-only">{{ $t('League') }}</label>
            <filter-tags
              ref="league"
              name="league"
              class="selectize selectize-multiple selectized our-stars-league"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="league"
              :placeholder="$t('League')"
              v-model="stateLeague"
              :options="league"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'league') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'league') }"/>
          </div>

          <!-- Opportunity Types Filter -->
          <div class="filter-group">
            <label class="sr-only">Request Types</label>
            <filter-tags
              ref="opportunity_types"
              name="opportunity_types"
              class="selectize selectize-multiple selectized our-stars-opportunity-types"
              @input="getStarsHelper"
              placeholder="Request Type"
              v-model="stateOpportunityTypes"
              key-context="opportunity_types"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              :fetch-results="fetchOpportunityResultsCallback"
              :options="opportunity_types"/>
          </div>

          <!-- Theme Filter -->
          <div class="filter-group" v-if="!$hasTagNodes">
            <label class="sr-only">{{ themeTitle }}</label>
            <filter-tags
              ref="theme"
              name="theme"
              class="selectize selectize-multiple selectized our-stars-theme"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="theme"
              :placeholder="themeTitle"
              v-model="stateTheme"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'theme') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'theme') }"
              :options="theme"/>
          </div>

          <div v-if="$budgetRangeTags" class="filter-group">
            <label class="sr-only">{{ $t('Budget Range') }}</label>
            <filter-tags
              ref="budgetRange"
              name="budgetRange"
              class="selectize selectize-multiple our-stars-budgetRange"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="budgetRange"
              :placeholder="$t('Budget Range')"
              v-model="stateBudgetRange"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'budgetRange') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'budgetRange') }"
              :options="budgetRange"
              :sortField="{field: 'name', direction: 'desc'}"/>
          </div>

          <div v-if="$highSchoolTags" class="filter-group">
            <label class="sr-only">High School Attended</label>
            <filter-tags
              ref="highSchool"
              name="highSchool"
              class="selectize selectize-multiple selectized our-stars-highSchool"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="highSchool"
              placeholder="High School Attended"
              v-model="stateHighSchool"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'highSchool') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'highSchool') }"
              :options="highSchool"/>
          </div>

          <div v-if="$collegeTags" class="filter-group">
            <label class="sr-only">College Attended</label>
            <filter-tags
              ref="college"
              name="college"
              class="selectize selectize-multiple our-stars-college"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="college"
              placeholder="College Attended"
              v-model="stateCollege"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'college') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'college') }"
              :options="college"/>
          </div>

          <div v-if="$degreeCompletedTags" class="filter-group">
            <label class="sr-only">Degree Completed</label>
            <filter-tags
              :multiple=false
              ref="degreeCompleted"
              name="degreeCompleted"
              class="selectize selectize-multiple our-stars-degreeCompleted"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="degreeCompleted"
              placeholder="Player Completed Degree"
              v-model="stateDegreeCompleted"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'degreeCompleted') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'degreeCompleted') }"
              :options="degreeCompleted"/>
          </div>

          <div v-if="$firstContractTags" class="filter-group">
            <label class="sr-only">Year Of First Contract</label>
            <filter-tags
              ref="firstContract"
              name="firstContract"
              class="selectize selectize-control selectize-multiple"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="firstContract"
              placeholder="Year Of First Contract"
              v-model="stateFirstContract"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'firstContract') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'firstContract') }"
              :options="firstContract"/>
          </div>

          <div v-if="$positionTags" class="filter-group">
            <label class="sr-only">{{ $t('Position') }}</label>
            <filter-tags
              ref="position"
              name="position"
              class="selectize selectize-multiple selectized our-stars-position"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="position"
              :placeholder="$t('Position')"
              v-model="statePosition"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'position') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'position') }"
              :options="position"/>
          </div>

          <div v-if="$awardTags" class="filter-group">
            <label class="sr-only">{{$t('Awards')}}</label>
            <filter-tags
              ref="award"
              name="award"
              class="selectize selectize-multiple selectized our-stars-award"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="award"
              :placeholder="$t('Awards')"
              v-model="stateAward"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'award') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'award') }"
              :options="award"/>
          </div>

          <div v-if="$proBowlTags" class="filter-group">
            <label class="sr-only">Have You Ever Made To a Pro Bowl</label>
            <filter-tags
              :multiple=false
              ref="proBowl"
              name="proBowl"
              class="selectize selectize-multiple our-stars-proBowl"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="proBowl"
              placeholder="Pro Bowl"
              v-model="stateProBowl"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'proBowl') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'proBowl') }"
              :options="proBowl"/>
          </div>

          <div v-if="$charityTags" class="filter-group">
            <label class="sr-only">{{ $t('Charity Partners') }}</label>
            <filter-tags
              ref="charity"
              name="charity"
              class="selectize selectize-multiple selectized our-stars-charity"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="charity"
              :placeholder="$t('Charity Partners')"
              v-model="stateCharity"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'charity') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'charity') }"
              :options="charity"/>
          </div>

          <div v-if="$brandTags" class="filter-group">
            <label class="sr-only">{{ $t('Brand Partners') }}</label>
            <filter-tags
              ref="sponsor"
              name="sponsor"
              class="selectize selectize-multiple selectized our-stars-charity"
              @input="getStarsHelper"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="sponsor"
              :placeholder="$t('Brand Partners')"
              v-model="stateSponsor"
              :fetch-results="(term, callback) => { fetchTagsResultsCallback(term, callback, 'sponsor') }"
              :fetch-more-results="(term, callback) => { fetchMoreTagsCallback(term, callback, 'sponsor') }"
              :options="sponsor"/>
          </div>

          <div class="filter-group" v-if="$retired" >
            <selectize
              class="selectize selectize-control selectize-single"
              name="retired"
              ref="retired"
              :options="retiredOptions"
              placeholder="Career Status"
              @input="getStarsHelper"
              v-model="stateRetired"/>
          </div>

          <div class="filter-group" v-if="$userIsAdmin && !$vlastMode">
            <label class="sr-only">Packages</label>
            <filter-tags
              ref="packages"
              name="packages"
              class="selectize selectize-multiple selectized our-stars-packages"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="packages"
              placeholder="Packages"
              v-model="statePackages"
              :fetch-results="fetchPackagesResultsCallback"
              @input="getStarsHelper"
              :options="packages"/>
          </div>

          <div class="filter-group" v-if="$userIsAdmin">
            <selectize
              class="selectize selectize-control selectize-single"
              name="search_area"
              :disable-delete="true"
              :options="managerOptions"
              placeholder="Management"
              @input="getStarsHelper"
              v-model="stateManager"/>
          </div>

          <div class="filter-group" v-if="$talentDateOfBirthEnabled" >
            <selectize
              class="selectize selectize-control selectize-single"
              name="age"
              :options="ageOptions"
              placeholder="Age"
              @input="getStarsHelper"
              v-model="stateAge"/>
          </div>

          <div class="filter-group" v-if="$userIsAdmin && !$vlastMode">
            <selectize
              class="selectize selectize-control selectize-single"
              name="visiblity"
              :options="visibilityOptions"
              placeholder="Visibility"
              @input="getStarsHelper"
              v-model="stateVisibility"/>
          </div>

          <div class="filter-group" v-if="$userIsAdmin">
            <div class="radio radio-override radio-primary" >
              <div class="radio-item">
                <input type="radio" id="all" value="all" v-model="stateApp" @input="getStarsHelper">
                <label for="all">All</label>
              </div>
              <div class="radio-item">
                <input type="radio" id="app" value="app" v-model="stateApp" @input="getStarsHelper">
                <label for="app">App Installed</label>
              </div>
              <div class="radio-item">
                <input type="radio" id="no-app" value="no-app" v-model="stateApp" @input="getStarsHelper">
                <label for="no-app">No App</label>
              </div>
            </div>
          </div>

          <div class="filter-group" v-if="$userIsAdmin && !$vlastMode">
            <filter-tags
              ref="talentBudgetCategories"
              name="talentBudgetCategories"
              class="selectize selectize-multiple selectized our-stars-talentBudgetCategories"
              @input="getStarsHelper"
              placeholder="Budget Category"
              v-model="stateTalentBudgetCategories"
              key-context="talentBudgetCategories"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              :sortField="{field: 'name', direction: 'asc'}"
              :options="talentCategoryOptions"/>
          </div>

          <div class="filter-group" v-if="$userIsAdmin && !$vlastMode">
            <filter-tags
              ref="talentBudgetCategoryRanges"
              name="talentBudgetCategoryRanges"
              class="selectize selectize-multiple selectized our-stars-talentBudgetCategoryRanges"
              :item-added="handleAddFlatFilterCallback"
              :item-removed="handleRemoveFlatFilterCallback"
              key-context="talentBudgetCategoryRanges"
              placeholder="Budget Range"
              v-model="stateTalentBudgetCategoryRanges"
              @input="getStarsHelper"
              :sortField="{field: 'name', direction: 'asc'}"
              :options="talentBudgetRangeOptions"/>
          </div>

        </div>
        <div class="flex flex-end filter-end">
          <span class="toggle-button" @click="toggleShowAll">
            <i class="fa" :class="[showAll ? 'fa-caret-up' : 'fa-caret-down']"/>
            {{ showAll ? 'Less' : 'More' }}
          </span>
          <span>
            {{ pagination.total }} {{ $starLabelPlural }}
          </span>
        </div>

        <div v-if="stateSearchTerms || (selectedNodes && selectedNodes.length)" class="spacer-x-4 flex flex-wrap align-center">
          <div class="margin-r-1">Searching for</div>
          <div class="applied-search applied-search--grey" v-if="stateSearchTerms">
            {{ stateSearchArea | sentenceCase }}: {{ stateSearchTerms }}
            <i class="fa fa-times" @click="() => { unselectSearch(index) }"/>
          </div>
          <div v-if="stateSearchTerms && (selectedNodes && selectedNodes.length)" class="margin-x-1">{{' and '}}</div>
          <div class="applied-search" v-for="node in selectedNodes" :key="node.id">
            <span v-for="ancestor in node.ancestors" :key="ancestor.id">{{ ancestor.name }} ></span>
            {{ node.name }}
            <i class="fa fa-times" @click="() => { unselectNode(node) }"/>
          </div>
        </div>

        <div class="filter-controls">
          <div class="button-group">
            <div class="button-group__item">
              <button type="button" class="btn btn-sm btn-default" @click="handleClearAllFilters" @submit.prevent>
                <span>Clear Filters</span>
              </button>
            </div>
            <div class="button-group__item">
              <button class="btn btn-sm btn-default" @click="handleClearTalentCallback" @submit.prevent>Clear {{$starLabelPlural}}</button>
            </div>
          </div>
          <div class="flex align-center">
            <div
              v-if="$showCategoryStats"
              class="flex"
              style="align-items: center; max-height: 44px; padding: 5px;">
              <div class="metric-text text-grey">Metrics for:</div>
              <filter-tags
                ref="category"
                name="category"
                class="selectize selectize-single selectized our-stars-categories"
                :item-added="handleAddFlatFilterCallback"
                :item-removed="handleRemoveFlatFilterCallback"
                :multiple="false"
                key-context="category"
                placeholder="All Categories"
                v-model="stateCategoryFilter"
                :fetch-results="fetchCategoriesCallback"
                @input="getStarsHelper"
                :options="categories"/>
            </div>
            <div class="flex align-center margin-l-2">
              <div class="metric-text text-grey margin-r-1">Completed data by period:</div>
              <div class="input-group">
                <flatpickr
                  v-model="completedBookingsDateRange"
                  :config="flatPickerDateConfig"
                  ref="date"
                  class="form-control"
                  @input="completedBookingDateRangeSelected"
                  name="completed_bookings_default_date_range"/>
                <span class="input-group-addon" style="padding-top: 0; padding-bottom: 0;" data-toggle>
                  <i class="fa fa-calendar"></i>
                </span>
              </div>
            </div>
            <div v-if="allowAddAll" class="button-group margin-l-1">
              <div class="button-group__item">
                <ladda-button class="btn btn-sm btn-primary" :click="handleAddAllTalentCallback">
                  <span>Add All</span>
                </ladda-button>
              </div>
            </div>
            <div v-else class="margin-l-1">
              <span>{{ selectedStars.length }} {{ $starLabelPlural }} selected</span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <info-alert v-if="stateVisibility === 'hidden'" type="warning" size="large" message="Please note these stars are set to hidden and may not wish to be added to this request." />
      <ul class="shortlist-modal-results row notification-talent-list" id="talent-list">
        <div class="text-center" v-if="haveNoTalent && notSearching">
          <h5>There are no {{$starLabelPlural}}. Try searching to find who you want.</h5>

          <button type="button" v-if="haveSearchText" @click="handleClearAllFilters" class="btn btn-default btn-sm">Clear Search</button>
        </div>
        <template v-else-if="notSearching">
          <slot name="talent-list">
            <ul class="talent-filter-list">
              <talent-filtering-talent-list-item v-for="talent in talentWithoutExistingProp" :key="talent.id" :talent="talent" :booking-budget="bookingBudget"/>
            </ul>
          </slot>
        </template>

        <div class="flex flex-row page-buttons">
          <button type="button" v-if="pagination.current_page > 1"
                  @click="handleGetPageStarsCallback(1)">
            &laquo;
          </button>
          <button type="button" v-if="pagination.current_page > 2"
                  @click="handleGetPageStarsCallback(pagination.current_page - 2)">
            {{ pagination.current_page - 2 }}
          </button>
          <button type="button" v-if="pagination.current_page > 1"
                  @click="handleGetPageStarsCallback(pagination.current_page - 1)">
            {{ pagination.current_page - 1 }}
          </button>
          <button disabled>
            {{ pagination.current_page }}
          </button>
          <button type="button" v-if="pagination.last_page > pagination.current_page"
                  @click="handleGetPageStarsCallback(pagination.current_page + 1)">
            {{ pagination.current_page + 1 }}
          </button>
          <button type="button" v-if="pagination.last_page > pagination.current_page + 1"
                  @click="handleGetPageStarsCallback(pagination.current_page + 2)">
            {{ pagination.current_page + 2 }}
          </button>
          <button type="button" v-if="pagination.current_page < pagination.last_page"
                  @click="handleGetPageStarsCallback(pagination.last_page)">
            &raquo;
          </button>

        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import FilterTags from '../misc/FilterTags'
import Selectize from '../ext/codium/CodiumSelectize'
import stateMapper from 'mixins/filtering/state-mapper'
import { mapState, mapActions, mapGetters } from 'vuex'
import { filter, find, merge, map, debounce, cloneDeep } from 'lodash'
import TalentFilteringTalentListItem from './TalentFilteringTalentListItem'
import InfoAlert from '../globals/InfoAlert'
import { http } from 'utils'
import Flatpickr from 'vue-flatpickr-component'
import { OpportunityTracker } from 'mixins/analytics'
import TagPicker from './TagPicker'

export default {
  mixins: [stateMapper, OpportunityTracker],

  props: {
    existingTalent: {
      required: false,
      default () {
        return []
      }
    },
    allowAddAll: {
      type: Boolean,
      default: true
    },
    stickyFilters: {
      type: Boolean,
      default: false
    },
    bookingBudget: {
      required: false,
      default: 0
    },
    booking: {
      required: false,
      default: 0
    },
    selectionLimited: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      loading: false,
      searching: false,
      search: {
        name: null
      },
      selectedNodes: [],
      searchModel: '',
      areaModel: 'name',
      showAll: false,
      filtersExpanded: true,
      initialCollapseClass: ['collapse'],
      opportunity_types: [],
      sport: [],
      theme: [],
      position: [],
      award: [],
      highSchool: [],
      packages: [],
      locations: [],
      gender: [],
      club: [],
      industry: [],
      league: [],
      categories: [],
      socialFollowing: [],
      client: [],
      searchTerms: [],
      regionOptions: [],
      clientUsers: [],
      budgetRange: [],
      clientPagination: {},
      interestCategories: [],
      interestCategoryPagination: {},
      specialistTopics: [],
      specialistTopicPagination: {},
      personalInterests: [],
      personalInterestPagination: {},
      completedBookingsDateRange: null,
      social_following: [
        {id: 1, text: 'Under 5k Followers'},
        {id: 2, text: '5k – 10k Followers'},
        {id: 3, text: '10k – 30k Followers'},
        {id: 4, text: '30k – 50k Followers'},
        {id: 5, text: '50k – 100k Followers'},
        {id: 6, text: '100k – 500k Followers'},
        {id: 7, text: '500k+ Followers'}
      ],
      managerOptions: [
        { id: 'no-selection', text: 'No Filter' },
        { id: 'manager', text: 'Has Manager' },
        { id: 'no-manager', text: 'No Manager' },
        { id: 'talent-notif', text: 'Talent Notifications' }
      ],
      ageOptions: [
        { id: 'u20', text: 'U20', low: 0, high: 20 },
        { id: 'u23', text: 'U23', low: 0, high: 23 },
        { id: 'o27', text: 'Over 27', low: 27 }
      ],
      visibilityOptions: [
        { id: 'hidden', text: 'Hidden' },
        { id: 'public', text: 'Public' },
        { id: 'private', text: 'Private' },
        { id: 'all', text: 'Public & Private' }
      ],
      verificationStatusOptions: [
        {id: 'active', text: 'Active | Verified'},
        {id: 'pending', text: 'Pending | Unverified'}
      ],
      talentBudgetCategories: [],
      talentBudgetCategoryRanges: [],

      getStarsDebounce: debounce(() => {
        this.searching = true
        if (this.booking && this.booking.category) {
          this.filters.category_id = this.booking.category.id
        }
        if (this.booking) {
          this.filters.booking_id = this.booking.id
        }

        return this.getStars(this.getFilterParams())
          .then(() => {
            this.searching = false
          })
      }, 800),

      flatPickerDateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        wrap: true,
        mode: 'range',
        altInputClass: 'input-group form-control input filter-calendar-input'
      }
    }
  },

  components: {
    TagPicker,
    TalentFilteringTalentListItem,
    FilterTags,
    Selectize,
    InfoAlert,
    Flatpickr
  },

  computed: {
    ...mapState('filtering', ['stars', 'pagination', 'filters', 'filtersDisabled', 'selectedStars']),
    ...mapGetters('filtering', ['sanitizedFilters', 'haveNoMoreStars']),
    ...mapGetters('tags', ['sanitizedPackages', 'sanitizedCategories', 'sanitizedTags']),

    searchAreaOptions () {
      const options = [
        { id: 'name', text: 'Name', show: true },
        { id: 'profile', text: 'Profile', show: true },
        { id: 'career', text: 'Career', show: this.$hasTagNodes },
        { id: 'all', text: 'Name + Profile', show: true }
      ]
      return options.filter(element => element.show)
    },

    searchPlaceholder () {
      switch (this.areaModel) {
        case 'career':
          return 'Search Career...'
        case 'name':
          return 'Search Names...'
        case 'profile':
          return 'Search Keywords...'
        case 'all':
          return 'Search Names/Keywords...'
        default:
          return 'Search...'
      }
    },

    basedInRegionOptions () {
      const locationSelections = this.stateBasedIn.length ? this.stateBasedIn.map(item => item.id) : [this.stateBasedIn]
      const selections = this.locations.filter(element => locationSelections.includes(element.id))
      let options = []
      selections.forEach(selection => {
        if (selection.location_regions) {
          options = options.concat(selection.location_regions.map(region => {
            return { id: region.id, text: region.name }
          }))
        }
      })
      return options
    },

    retiredOptions () {
      const options = [
        { id: 'retired', text: this.$t('Retired') },
        { id: 'active', text: 'Active' }
      ]
      if (this.$isNflClient) {
        options.push({ id: 'coach', text: 'Coach' })
      }
      return options
    },

    talentCategoryOptions () {
      return [
        { id: 'ambassadorship', text: 'Ambassadorship (6 month)' },
        { id: 'event_appearance', text: 'Event Appearance' },
        { id: 'guest_speaking', text: 'Guest Speaking' },
        { id: 'social_media_post', text: 'Social Media Grid Post' },
        { id: 'social_media_story', text: 'Social Media Story' }
      ]
    },

    talentBudgetRangeOptions () {
      return [
        { id: '0-499', text: '0 - $499' },
        { id: '500-999', text: '$500 - $999' },
        { id: '1000-2499', text: '$1,000 - $2,499' },
        { id: '2500-4499', text: '$2,500 - $4,499' },
        { id: '5000-7499', text: '$5,000 - $7,499' },
        { id: '7500-9999', text: '$7,500 - $9,999' },
        { id: '10000-14999', text: '$10,000 - $14,999' },
        { id: '15000-19999', text: '$15,000 - $19,999' },
        { id: '20000-29999', text: '$20,000 - $29,999' },
        { id: '30000-39999', text: '$30,000 - $39,999' },
        { id: '40000-49999', text: '$40,000 - $49,999' },
        { id: '50000-', text: '$50,000+' }
      ]
    },

    genderOptions () {
      if (this.$isWSL) {
        return [
          { id: 'male', text: 'Male (CT)' },
          { id: 'female', text: 'Female (CT)' }
        ]
      }
      return [
        { id: 'male', text: 'Male' },
        { id: 'female', text: 'Female' },
        { id: 'other', text: 'Other' }
      ]
    },

    /**
     * Filter out the existing talent against the booking and already selected talent from previous add all talent queries.
     *
     * @return array
     */
    talentNotSelected () {
      return filter(this.talentWithoutExistingProp, (talent) => {
        return find(this.selectedStars, (existing) => existing.id === talent.id) === undefined
      })
    },

    /**
     * Filter out the existing talent against the booking from the search results.
     *
     * @return array
     */
    talentWithoutExistingProp () {
      return filter(this.stars, (talent) => {
        return find(this.existingTalent, (existing) => existing.id === talent.id) === undefined
      })
    },

    showSelectedSummary () {
      return false
    },

    /**
     * Determine if we have no talent without the existing talent.
     *
     * @return bool
     */
    haveNoTalent () {
      return this.stars.length === 0
    },

    /**
     * Determine if we are not searching.
     *
     * @return bool
     */
    notSearching () {
      return !this.searching
    },

    /**
     * Determine if we have search text.
     *
     * @return bool
     */
    haveSearchText () {
      return this.searchTerms !== null
    },

    themeTitle () {
      return this.$t('Specialist Topics')
    },

    trackingDetails () {
      const filterFields = []
      let countApplied = 0
      Object.keys(this.filters).forEach(key => {
        if (key !== 'search_area' && key !== 'search_terms') {
          filterFields.push({
            fieldName: key,
            fieldValue: this.filters[key]
          })
          if (this.filters[key] !== null && this.filters[key] !== '') {
            if (Array.isArray(this.filters[key])) {
              if (this.filters[key].length > 0) {
                countApplied++
              }
            } else {
              countApplied++
            }
          }
        }
      })
      const searchFields = [{
        fieldName: this.stateSearchArea,
        fieldValue: this.stateSearchTerms
      }]
      const pageName = this.$route.name
      return { countApplied, pageName, searchFields, filterFields }
    }
  },

  created () {
    if (this.$userIsAdmin) {
      this.getRegions()
        .then((response) => {
          this.regionOptions = map(response.data, region => ({id: region.id, text: region.name}))
          this.stateRegion = [this.$user.region_id]
          this.getStarsDebounce()
        })
    } else {
      this.getStarsDebounce()
    }
  },

  mounted () {
    if (this.$bus) {
      this.$bus.$on('removeFilter', this.handleRemoveFilterCallback)
    }
    this.completedBookingsDateRange = this.$clientConfig.tenant_details.completed_bookings_default_date_range
  },

  methods: {
    ...mapActions('filtering', ['clearAllFilters', 'clearFilter', 'getStars', 'getAllStarsFiltered', 'removeFilter', 'addFlatFilter', 'getPageStars', 'setSelectedStars']),
    ...mapActions('tags', ['getPackages', 'getCategories', 'getTags', 'getNextTags']),
    ...mapActions('region', ['getRegions']),

    handleSearchSelected () {
      this.stateSearchTerms = cloneDeep(this.searchModel)
      this.stateSearchArea = this.areaModel
      this.searchModel = ''
      return this.getStarsHelper('search')
    },

    unselectSearch () {
      this.stateSearchTerms = null
      return this.getStarsHelper('search')
    },

    handleNodeSelected (node) {
      this.selectedNodes.push(node)
      return this.getStarsHelper('search')
    },

    unselectNode (node) {
      const index = this.selectedNodes.findIndex(element => element.id === node.id)
      if (index !== -1) {
        this.selectedNodes.splice(index, 1)
      }
      return this.getStarsHelper('search')
    },

    toggleShowAll () {
      this.showAll = !this.showAll
    },

    completedBookingDateRangeSelected () {
      if (this.completedBookingsDateRange.includes('to')) {
        this.getStarsHelper()
      }
    },

    handleClearFilter (filter) {
      this.clearFilter(filter)
      this.$refs[filter].removeAllTags()
      this.getStarsHelper()
    },

    handleClearAllFilters () {
      this.clearAllFilters()
      this.selectedNodes = []
      const refs = [
        'social_following',
        'client',
        'sport',
        'gender',
        'based_in',
        'club',
        'industry',
        'availableIn',
        'league',
        'opportunity_types',
        'theme',
        'position',
        'award',
        'highSchool',
        'packages',
        'retired',
        'location_region',
        'budgetRange',
        'interestCategories',
        'specialistTopics',
        'personalInterests',
        'talentBudgetCategories',
        'talentBudgetCategoryRanges',
        'verification_status'
      ]
      refs.forEach(ref => {
        if (this.$refs[ref]) {
          this.$refs[ref].removeAllTags()
        }
      })

      this.getStarsHelper()
    },

    getFilterParams () {
      const params = this.sanitizedFilters

      if (params.age) {
        const selectedAge = this.ageOptions.find(age => age.id === params.age)

        if (selectedAge) {
          params.age_low = selectedAge.low
          params.age_high = selectedAge.high
        }

        params.age = undefined
      }

      if (this.completedBookingsDateRange) {
        params.completedBookingsDateRange = this.completedBookingsDateRange
      }

      params.searches = this.appliedSearches
      params.career = this.selectedNodes.map(element => element.id)

      return params
    },

    getStarsHelper (area = null) {
      if (area === 'search') {
        this.trackSearchApply()
      } else {
        this.trackFilterApply()
      }
      return this.getStarsDebounce()
    },

    /**
     * Handle adding talent to the array of additional talent.
     *
     * @return void
     */
    handleAddAllTalentCallback () {
      return this.getAllStarsFiltered(this.sanitizedFilters)
    },

    /**
     * Handle adding talent to the array of additional talent.
     *
     * @return void
     */
    handleClearTalentCallback () {
      this.loading = true
      this.setSelectedStars([]).then(() => {
        this.loading = false
      })
    },

    /**
     * Add a flat filter to the state. Merge in the key context to the filter.
     *
     * @return void
     */
    handleAddFlatFilterCallback (filter, key) {
      this.addFlatFilter(merge(filter, { key }))
    },

    handleRemoveFlatFilterCallback (filter, key) {
      let component = this.$refs[key]

      this.removeFilter({ ...filter, key })

      // If we found a matching component for the key context then we'll remove the tag from the
      // components selected tags that it tracks internally.
      if (component !== undefined) {
        component.removeTag(filter)
      }
    },

    /**
     * Fetch location results callback.
     *
     * @return void
     */
    fetchLocationResultsCallback (term, callback) {
      let params = { term }

      this.$http.get('locations', { params })
        .then((response) => {
          callback(
            this.locations = map(response.data, this.mapObjectResponseForSelectize)
          )
        })
    },

    /**
     * Fetch opportunity results callback.
     *
     * @return void
     */
    fetchOpportunityResultsCallback (term, callback) {
      let params = {
        term,
        level: 'all'
      }

      this.$http.get('opportunities', { params })
        .then((response) => {
          callback(
            map(response.data, this.mapObjectResponseForSelectize)
          )
        })
    },

    /**
     * Fetch packages results callback.
     *
     * @return void
     */
    fetchPackagesResultsCallback (term, callback) {
      this.getPackages().then((response) => {
        callback(
          this.sanitizedPackages
        )
      })
    },

    /**
     * Fetch packages results callback.
     *
     * @return void
     */
    fetchCategoriesCallback (term, callback) {
      this.getCategories().then((response) => {
        callback(
          this.sanitizedCategories
        )
      })
    },

    /**
     * Fetch tag results callback.
     *
     * @return void
     */
    fetchTagsResultsCallback (term, callback, type) {
      let params = {
        term,
        type,
        status: 'active',
        sort: 'name'
      }

      this.getTags(params).then((response) => {
        callback(this.sanitizedTags(type))
      })
    },

    fetchMoreTagsCallback (term, callback, type) {
      let params = {
        term,
        type,
        sort: 'name'
      }
      this.getNextTags(params).then((response) => {
        callback(this.sanitizedTags(type))
      })
    },

    fetchInterestCategoriesCallback (search, callback) {
      let params = {
        search
      }
      return http.get('interest-categories', params).then(response => {
        this.interestCategories = map(response.data.data, interest => ({id: interest.id, text: interest.name}))
        this.interestCategoryPagination = response.data.meta
        callback(this.interestCategories)
      })
    },

    fetchMoreInterestCategoriesCallback (search, callback) {
      let params = {
        search
      }
      if (this.interestCategoryPagination && this.interestCategoryPagination.current_page < this.interestCategoryPagination.last_page) {
        return http.get('interest-categories', params).then(response => {
          const newInterestCategories = map(response.data.data, interest => ({id: interest.id, text: interest.name}))
          this.interestCategories.push(...newInterestCategories)
          this.interestCategoryPagination = response.data.meta
          callback(this.interestCategories)
        })
      }
    },

    fetchSpecialistTopicsCallback (search, callback) {
      let params = {
        search
      }
      return http.get('interest-categories', params).then(response => {
        this.specialistTopics = map(response.data.data, interest => ({id: interest.id, text: interest.name}))
        this.specialistTopicPagination = response.data.meta
        callback(this.specialistTopics)
      })
    },

    fetchMoreSpecialistTopicsCallback (search, callback) {
      let params = {
        search
      }
      if (this.specialistTopicPagination && this.specialistTopicPagination.current_page < this.specialistTopicPagination.last_page) {
        return http.get('interest-categories', params).then(response => {
          const newSpecialistTopics = map(response.data.data, interest => ({id: interest.id, text: interest.name}))
          this.specialistTopics.push(...newSpecialistTopics)
          this.specialistTopicPagination = response.data.meta
          callback(this.specialistTopics)
        })
      }
    },

    fetchPersonalInterestsCallback (search, callback) {
      let params = {
        search
      }
      return http.get('personal-interests', params).then(response => {
        this.personalInterests = map(response.data.data, interest => ({id: interest.id, text: interest.name}))
        this.personalInterestPagination = response.data.meta
        callback(this.personalInterests)
      })
    },

    fetchMorePersonalInterestsCallback (search, callback) {
      let params = {
        search
      }
      if (this.personalInterestPagination && this.personalInterestPagination.current_page < this.personalInterestPagination.last_page) {
        return http.get('personal-interests', params).then(response => {
          const newPersonalInterests = map(response.data.data, interest => ({id: interest.id, text: interest.name}))
          this.personalInterests.push(...newPersonalInterests)
          this.personalInterestPagination = response.data.meta
          callback(this.personalInterests)
        })
      }
    },

    /**
     * Handle removing a selected filter.
     *
     * @return void
     */
    handleRemoveFilterCallback (filter) {
      let component = this.$refs[filter.key]

      this.removeFilter(filter)

      // If we found a matching component for the key context then we'll remove the tag from the
      // components selected tags that it tracks internally.
      if (component !== undefined) {
        component.removeTag(filter)
      }
    },

    /**
     * Map a standard object response to a selectize format.
     *
     * @return object
     */
    mapObjectResponseForSelectize (object) {
      return { id: object.id, text: object.name, location_regions: object.location_regions }
    },

    handleGetPageStarsCallback (page) {
      return this.getPageStars({ ...this.sanitizedFilters, page, booking_id: this.booking.id })
    },

    fetchClientsCallback (keywords, callback) {
      return http.get('clients/company', { params: { status: 'active', keywords } })
        .then((response) => {
          this.clientUsers = map(response.data.data, client => ({id: client.company, text: client.company}))
          this.clientPagination = response.data.meta
          callback(this.clientUsers)
        })
    },

    fetchNextClientsCallback (keywords, callback) {
      if (this.clientPagination && this.clientPagination.current_page < this.clientPagination.last_page) {
        return http.get('clients/company', { params: { status: 'active', keywords, page: this.clientPagination.current_page + 1 } })
          .then((response) => {
            const newClientUsers = map(response.data.data, client => ({id: client.company, text: client.company}))
            this.clientUsers.push(...newClientUsers)
            this.clientPagination = response.data.meta
            callback(this.clientUsers)
          })
      }
    },

    trackFilterApply () {
      // this.trackEvent(this.analytics.V2.FilterApplyEvent, this.trackingDetails)
    },

    trackSearchApply () {
      // this.trackEvent(this.analytics.V2.SearchApplyEvent, this.trackingDetails)
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/sass/mixins/global-mixins';

.our-stars-categories {
  .selectize-input {
    width: 200px;
    min-height: 34px !important;
    max-height: 34px !important;
    padding: 0;
    padding-left: 5px;
    margin-left: 5px;
  }
}

.our-stars-search {
  width:100%;
  height: 46px;
  font-size: 16px;
  padding: 6px 12px;
}

.talent-filter-list {
  display: flex;
  flex-flow: row wrap;
  padding: 0 30px;
}
.filter-panel {
  &.is-sticky {
    position: sticky;
    top: 0;
    width: 100%;
    background-color: #fff;
    z-index: 99;
  }
}
.filter-row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 30px;
  width: calc(100% + 10px);
  margin: 0 -5px;
  & > *:not(.selectize-control) {
    width: 100%;
    @media (min-width: 480px) and (max-width: 1279px) {
      width: 50%;
    }
    @media (min-width: 1280px) {
      width: 50%;
      @include when-in-modal {
        width: 25%;
      }
    }
    padding: 0 5px 5px;
  }
  .selectize-control {
    width: 100%;
  }
}
.filter-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  padding: 15px 30px 0px 30px;
}
.button-group {
  display: inline-flex;
  margin: 0 -5px;
  &__item {
    padding: 5px;
  }
}
.search-bar {
  width: 100%;
  padding: 10px 30px;
  margin-bottom: 15px;
  &__input {
    min-width: 100px;
    margin-right: 10px;
    max-width: 66%;
  }
  &__select {
    width: 30%;
  }
}
.filter-end {
  padding: 0px 30px;
  justify-content: space-between;
  .toggle-button {
    color: var(--brand-primary);
    cursor: pointer;
  }
}
.radio-override {
  padding: 10px 0;
  border: 1px #2a2a2a solid;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: 46px;
  .radio-item {
    padding-top: 5px;
    padding-left: 10px;
  }
  label {
    padding-left: 20px;
    &::before, &::after {
      margin-left: 0px;
    }
  }
  input[type="radio"] {
    padding-left: 30px;
    margin-left: 0px;
    &::before {
      margin-left: 0px;
    }
  }
}

.page-buttons {
  justify-content: center;
  padding: 0px 45px;
  button {
    padding: 10px 15px;
    border-radius: 5px;
    border: none;
    margin: 0px 2px;
  }
}
.filter-calendar-input {
  padding: 10px;
  height: 34px;
  font-size: 10px;
  min-width: 150px;
  border: none;
}
.metric-text {
  font-weight: 700;
  letter-spacing: 0.5px;
}
.applied-search {
  background: black;
  color: white;
  padding: 4px 12px;
  border: 2px solid black;
  font-size: 12px;
  font-family: Open Sans,Sans-serif;
  letter-spacing: 1px;
  font-weight: 700;
  cursor: pointer;
  margin-right: 4px;
  margin-top: 6px;
  margin-bottom: 6px;
  &--grey {
    background: #e3e3e3;
    color: black;
    border: 2px solid #e3e3e3;
  }
}
</style>
